import {Component, Input, OnInit} from '@angular/core';
import {DiscountCondition, DiscountConditionType} from "../../../../common";

@Component({
  selector: 'discount-time-condition',
  standalone: false,
  template: `
    <div *ngIf="!skip" i18n>on all orders between {{timeFrom|date:'shortTime'}} and {{timeTo|date:'shortTime'}}</div>
  `
})

export class DiscountTimeCondition implements OnInit {
  @Input() condition: DiscountCondition;

  timeFrom: Date;
  timeTo: Date;
  skip: boolean = false;

  ngOnInit(): void {
    if (this.condition.type == DiscountConditionType.Time) {
      this.timeFrom = this.condition.parseHours(this.condition.from_hour);
      this.timeTo = this.condition.parseHours(this.condition.to_hour);
    } else {
      this.skip=true;
    }
  }
}
